import axios from 'axios';
export default class Licenses{
    constructor(profile){
        this.profilePage=profile;
        this.licensesListHTML=$("#licenses-manager-list");
        this.updateLicensesButton=$("#update-licenses-modal");
        this.managerModal=$("#license-manager-modal");
        this.licenses=[];
        this.plan;
        this.myLicenses=[];
        this.quantity=1;
        this.interval="month";
        this.licenseSummaryItems=$("#license-manager-summary");
        this.licenseSummaryTotal=$("#license-manager-total");
        this.agreeTermsCheckbox=$("#license_privacy_policy");
        this.errorMessage=$("#license_response_error");
        this.initialSelectedIds=[];
        this.onClose=()=>{};
    };

    load(){
        $("#license_privacy_policy_error").html('');
        this.agreeTermsCheckbox.prop({checked:false});
        this.agreeTermsCheckbox.off('change');
        this.agreeTermsCheckbox.on('change',()=>{
            if(this.agreeTermsCheckbox.is(':checked')){
                $("#license_privacy_policy_error").html('');
            }
        })

        //summary clean
        this.licenseSummaryTotal.html(`$0.00/${this.interval}`)
        this.licenseSummaryItems.html(`<tr>
                <td class="vertical-align-top" colspan=4 >
                    <div class="d-flex justify-content-center mb-1 w-100">
                        <span class="invoice-item-name text-invoice-amount">No selected licenses</span>
                    </div>
                </td>
        </tr>`);

        this.setError('');
        this.disableSubmitButton();
        this.setLicensesLoading();
        this.updateLicensesButton.off();
        this.updateLicensesButton.on('click',()=>{
            this.updateLicenses();
        });
        this.managerModal.modal('show')
        this.getLicenses();
    };


    getLicenses(){
        axios.get('/profile/billing/licenses').then(response=>{
            if(response.data.available){
                this.available=response.data.available;
            }
            if(response.data.plan && response.data.plan.length){
                this.plan=response.data.plan;
                this.interval=this.plan.interval;
                // this.quantity=this.plan.licenses > 1 ? this.plan.licenses+1 : 1;
            }
            if(response.data.licenses){
                this.myLicenses=response.data.licenses;
            }
            this.renderAvailableLicenses();
        }).catch(err=>{
            console.error(err);
        })
    };

    renderAvailableLicenses(){
        // if(this.plan){
            // if(this.quantity==1){
            //     $('#license-manager-licenses-toggle').removeClass('has-licenses');
            // }else{
                $('#license-manager-licenses-toggle').addClass('has-licenses');
            // }
            if(this.available && this.available.length){
                this.licensesListHTML.html('')
                this.available.forEach(license=>{
                    // if(license.owned){
                    //     this.initialSelectedIds.push(license.id);
                    // }
                    this.renderLicense(license);
                })
                this.onSelectionChanged();
            }else{
                //no available licenses
            }
        // }else{
        //     // you should have a active plan
        // }
    }

    setLicensesLoading(){
        this.licensesListHTML.html(`
        <tr>
            <td class="vertical-align-top border-0 px-0 py-1" colspan=3>
                <div class="d-flex w-100 justify-content-center align-items-center loading-licenses flex-column">
                    <div class="spinner-grow text-secondary mb-3" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <span>Loading available licenses...</span>
                </div>
            </td>
            </tr>
        `);
    }
    renderLicense(license){
        const manager=this;
        const periodEnd=moment(this.profilePage.subscription.period_end);
        const licenseName=$("<td/>",{
            nowrap:'',
            class:'vertical-align-top border-0 px-0 py-2 sm-vertical-align-middle',
            html:`<div class="d-flex align-items-center mb-1">
                <div class="d-flex flex-column text-lg flex-1 max-width-440 break-word">
                    <span class="invoice-item-name text-invoice-amount text-lg sm-text-small">${license.plan.name}</span>
                    <small class="invoice-item-desc text-invoice-desc sm-hidden">${license.plan.description}</small>
                    ${ license.canceled > 0 ? `<small class="invoice-item-desc text-info sm-text-small" style="white-space: break-spaces;"><i class="fa fa-info-circle" aria-hidden="true"></i> Additional ${license.canceled} ${license.plan.name} licenses are available for use until <u>${periodEnd.format('MMM Do')}</u>${periodEnd.format(', YYYY')}</small>` : ''}
            </div>
           </div>`
        });

        const licensePrice=$("<td/>",{
            class:"vertical-align-top border-0 px-0 py-2 sm-vertical-align-middle",
            html:`<div class="d-flex justify-content-end align-items-start mb-1 price-cell">
                <span class="invoice-line-amount text-invoice-amount text-lg sm-text-small">$${license.price /100 }/${license.interval == "month" ? "mo" : "y"}</span>
            </div>`
        });

        const licenseQtyInput=$("<input/>",{
            class:"addon-qty-input",
            name:"purchase_license_qty_input",
            type:"number",
            style:'max-width:120px',
            min:license.minQty,
            step:1,
            'license-id':license.id,
            // max:this.quantity,
            value:license.qty
        }).on('change',this.onSelectionChanged.bind(manager));
        const licenseQtyMinus=$("<button/>",{
            class:"mui-btn mui-btn--small mui-btn--gray mui-btn--fab",
            html:`<i class="fa fa-minus" aria-hidden="true"></i>`
        }).on('click',()=>{
            licenseQtyInput[0].stepDown();
            licenseQtyInput.trigger('change')
        })
        const licenseQtyPlus=$("<button/>",{
            class:"mui-btn mui-btn--small mui-btn--primary mui-btn--fab",
            html:`<i class="fa fa-plus" aria-hidden="true"></i>`
        }).on('click',()=>{
            licenseQtyInput[0].stepUp();
            licenseQtyInput.trigger('change')
        })

        const licenseActionsContainer=$("<div/>",{
            class:"d-flex justify-content-end align-items-start mb-1",
            html:[licenseQtyMinus,licenseQtyInput,licenseQtyPlus]
        })
        const licenseActions=$("<td/>",{
            class:"vertical-align-top border-0 px-0 py-1 show-on-licenses",
            html:[licenseActionsContainer]
        });

       
        const licenseRow=$("<tr/>",{
            html:[licenseName,licensePrice,licenseActions],
        })

        this.licensesListHTML.append(licenseRow);
        
    };

    getSelectedLicenseIds(){
        const selectedIds=[];
        this.licensesListHTML.find(`input[name='purchase_license_qty_input']`).each((i,input)=>{
            // console.log("checking license",$(input).val())
            if(parseInt($(input).val()) > 0){
                selectedIds.push({id:parseInt($(input).attr('license-id')),qty:parseInt($(input).val())});
            }
        })
        return selectedIds
    };

    getCheckboxSelectedLicenses(){
        const selectedIds=[];
        this.licensesListHTML.find(`input[name='manager_license_selected_checkbox']`).each((i,input)=>{
            // console.log("checking license",$(input).val())
            if(parseInt($(input).val()) > 0 && $(input).is(':checked')){
                selectedIds.push({id:parseInt($(input).val()),qty:1});
            }
        })
        return selectedIds
    }

    onSelectionChanged(){
        const selectedIdQTY=this.getSelectedLicenseIds();
        console.log("selected licenses",selectedIdQTY);
        const selectedIds=selectedIdQTY.map(a=>a.id);
        const selectedLicenses=this.available.filter(license=>selectedIds.includes(license.id));
        for (let index = 0; index < selectedLicenses.length; index++) {
            const license = selectedLicenses[index];
            license.qty=selectedIdQTY.find(a=>a.id==license.id).qty;

        }
        // console.log("Selected licenses summary",selectedLicenses)
        this.printSummary(selectedLicenses);
        // console.log(`Comparing (${selectedIds.sort().toString()}) with (${this.initialSelectedIds.sort().toString()})`)
        this.setError('');
        if(this.haveLicensesChanged(selectedIdQTY)){
            this.enableSubmitButton();
        }else{
            this.disableSubmitButton();
        }

    }

    haveLicensesChanged(selectedLicenses){
        const initialIds=this.myLicenses.map(a=>a.id);
        const nowIds=selectedLicenses.map(a=>a.id);
        if(initialIds.sort().toString() != nowIds.sort().toString()){
            return true;
        }

        for (let index = 0; index < selectedLicenses.length; index++) {
            const license = selectedLicenses[index];
            const myLicense = this.myLicenses.find(a=>a.id==license.id);
            if(!myLicense){return true}
            if(license.qty != myLicense.qty){
                return true
            }
        }
        return false;
    };
    printSummary(selectedLicenses){
        
        if(selectedLicenses.length){
            let summaryTotal=0;
            this.licenseSummaryItems.html('');
            selectedLicenses.forEach(license=>{
                const interval=license.interval;
                const rate=license.price;
                const licensePrice=rate * license.qty;
                summaryTotal+=licensePrice;
               this.licenseSummaryItems.append(`<tr>
                    <td class="vertical-align-top">
                        <div class="d-flex flex-column mb-1">
                            <span class="invoice-item-name text-invoice-amount">${license.plan.name} - ${interval}</span>
                        </div>
                    </td>
                    <td class="vertical-align-top">
                        <div class="d-flex flex-column mb-1">
                            <span class="invoice-item-name text-invoice-amount">${license.qty}</span>
                        </div>
                    </td>
                    <td class="vertical-align-top">
                        <div class="d-flex flex-column mb-1">
                            <span class="invoice-item-name text-invoice-amount">$${rate/100}</span>
                        </div>
                    </td>
                    <td class="vertical-align-top">
                        <div class="d-flex justify-content-end align-items-start mb-1">
                            <span class="invoice-line-amount text-invoice-amount">$${licensePrice/100}</span>
                        </div>
                    </td>
                </tr>`);
            });

            this.licenseSummaryTotal.html(`$${summaryTotal/100}`)
        }else{
            this.licenseSummaryTotal.html(`$0.00`)
            this.licenseSummaryItems.html(`<tr>
                <td class="vertical-align-top" colspan=4 >
                    <div class="d-flex justify-content-center mb-1 w-100">
                        <span class="invoice-item-name text-invoice-amount">No selected licenses</span>
                    </div>
                </td>
            </tr>`);
        }
    };


    disableSubmitButton(){
        this.updateLicensesButton.prop({disabled:true})
    }

    enableSubmitButton(){
        this.updateLicensesButton.prop({disabled:false})
    }


    updateLicenses(){
        //validate
        this.disableSubmitButton();
        const agreementChecked=this.agreeTermsCheckbox.is(':checked');
        if(!agreementChecked){
            $("#license_privacy_policy_error").html('Please agree to our Terms & Conditions and Privacy Policy.');
            this.enableSubmitButton()
            return;
        }
        $("#license_privacy_policy_error").html('');
        const selectedLicenses=this.getSelectedLicenseIds();

        axios.put('/profile/billing/licenses',{licenses:selectedLicenses,interval:this.interval}).then(response=>{
            console.log("Updated licenses",response.data);
            if(!response.data.error){
                this.profilePage.getPlan();
                this.profilePage.getUpcomingInvoice();
                this.closeModal(true);
            }else{
                this.setError(response.data.message);
                this.enableSubmitButton();
            }   
        }).catch(err=>{
            console.error(err);
            this.setError("Something went wrong.");
        })

    }

    setError(error=''){
        this.errorMessage.html(error);
    }
    closeModal(success=false){
        this.managerModal.modal('hide');
        this.setLicensesLoading();
        this.setError('');
        $("#license_privacy_policy_error").html('');
        this.agreeTermsCheckbox.prop({checked:false});
        this.disableSubmitButton();
        this.updateLicensesButton.off();
        this.agreeTermsCheckbox.off('change');
        this.onClose(success);

    }
};